import { ILiveStreamSettings, ITimeRange } from 'AppTypes'

export class LiveStreamSettings implements ILiveStreamSettings {
  storeId: string

  isPublish: boolean

  timeToPlay: string

  timeRanges: ITimeRange[]

  constructor (storeId: string, isPublish: boolean, timeToPlay: string, timeRanges: ITimeRange[]) {
    this.storeId = storeId
    this.isPublish = isPublish
    this.timeToPlay = timeToPlay
    this.timeRanges = timeRanges
  }
}

export const AT_WORK_TIME = 'AtWorkTime'

export const SPECIFY_TIME = 'SpecifyTime'

export const ALL_DAY = 'AllDay'
